import { Box, Text } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'

import i18n from 'modules/core/lib/i18n'

interface RoomInfoProps {
  title?: string
  description?: string
  handleJoin: () => void
  handleLeave: () => void
}

export const RoomInfo = ({ title, description, handleJoin, handleLeave }: RoomInfoProps) => {
  return (
    <Box
      alignItems="flexStart"
      justifyContent="center"
      flexNoShrink
      flexDirection="column"
      width="s300"
      gap="s6"
    >
      <Text.Header1>{title ?? i18n.t('meetings.prejoin.room_info.default_title')}</Text.Header1>
      <Text.Normal size="200">
        {description ?? i18n.t('meetings.prejoin.room_info.default_description')}
      </Text.Normal>
      <Box paddingTop="s12" flexDirection="row" gap="s12">
        <Button
          label={i18n.t('meetings.prejoin.room_info.enter_meeting_button')}
          onClick={handleJoin}
          size="md"
          variant="default"
        />
        <Button label={i18n.t('common.cancel')} onClick={handleLeave} size="md" variant="outline" />
      </Box>
    </Box>
  )
}
